import { RepositoryDragAndDropController } from './repository-drag-and-drop.controller'

function repositoryDragAndDrop () {
  return {
    scope: {
      modalState: '<',
      isOrganized: '<',
      folder: '<',
      mainContent: '<'
    },
    restrict: 'E',
    templateUrl: '/repository/directives/repository-drag-and-drop/repository-drag-and-drop.html?$$REVISION$$',
    controller: RepositoryDragAndDropController
  }
}

export { repositoryDragAndDrop }
